module.exports = __webpack_public_path__ + "static/img/ECW.3f34bf90.svg";